<template>
  <div style="background-color: black" class="contenedorMapa">
    <Alert :text="'Credenciales correctas'" :tiempo="2000" :color="'green'" />
    <!-- mostrar menu izquierda -->
    <div class="menuLeft" v-if="cliente">
      <ButtonSubMenu :infocliente="infocliente" />
    </div>
    <div justify="space-around" class="contenedorMapa">
      <!-- mostrar componente googlemaps-->
      <TravelMap v-if="llamadaApi" />
      <div v-else class="loader" style="width: 100%; height: 100%">
        <div class="loader-wheel"></div>
        <div class="loader-text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import TravelMap from "../../components/googleMaps/TravelMap.vue";
import ButtonSubMenu from "../../components/menuDial/ButtonSubMenu.vue";
import Alert from "../../components/common/Alert.vue";
import Cookies from "js-cookie";
export default {
  name: "Sig",
  components: {
    TravelMap,
    ButtonSubMenu,
    Alert,
  },
  data() {
    return {
      campos: null,
      cliente: null,
      opciones: null,

      itemOpcionPreferida: null,
      datosApi: null,
      itemMaps: {},

      marcadores: [],

      infocliente: {},

      llamadaApi: null,
    };
  },
  created() {

    if (Cookies.get("tokenSig") == undefined) {
      console.log("no se encontró la cookie");
      this.$router.push("*");
    } else {
      console.log("hay cookie");
      let test = process.env.VUE_APP_URL;
      this.cargarDatosApi();
    }
  },
  methods: {
    /**
     * se hace una consulta a la api, lo retornado
     * se guarda en las variables del data:
     * -campos, cliente
     * @function cargarDatosApi()
     * @returns {void}
     */
    cargarDatosApi() {
      let respuesta;
      let me = this;

      const config = {
        headers: {
          Accept: "application/vnd.api.lem.v1+json",
          Authorization: `Bearer ${Cookies.get("tokenSig")}`,
        },
      };

      this.axios
        .post(`${process.env.VUE_APP_URL}/api/sig`, [], config)
        .then((response) => {
          respuesta = response.data;
          me.datosApi = respuesta;
          me.campos = JSON.parse(JSON.stringify(me.datosApi.campos));
          me.cliente = JSON.parse(JSON.stringify(me.datosApi.cliente));
          me.opciones = JSON.parse(
            JSON.stringify(me.datosApi.campos[0].opciones)
          );

          me.infocliente = {
            cliente: me.cliente,
            opciones: me.opciones,
            campos: me.campos,
          };

          for (let index = 0, n = this.campos[0].objetos.length; index < n; index++) {
            for (let subindex = 0, l = this.campos[0].objetos[index].subobjetos.length; subindex < l; subindex++) {
              this.$echo.private('sig_subobjeto.' + this.campos[0].objetos[index].subobjetos[subindex].id_sig_subobjeto).listen('InformacionDeSubobjetoSigActualizada', (payload) => {
                this.campos[0].objetos[index].subobjetos[subindex].color = payload.color;
                this.campos[0].objetos[index].subobjetos[subindex].etiqueta = payload.etiqueta;
              });
            }
          }
          let objetosSig = this.campos[0].objetos.map((objeto) => {
            const posicionCentral = objeto.poligonos[0].centro
              ? objeto.poligonos[0].centro
              : {
                lat: objeto.poligonos[0].caminos.reduce((sum, point) => sum + point.lat, 0) / objeto.poligonos[0].caminos.length,
                lng: objeto.poligonos[0].caminos.reduce((sum, point) => sum + point.lng, 0) / objeto.poligonos[0].caminos.length
              };

            return {
              id_sig_objeto: objeto.id_sig_objeto,
              nombre: objeto.nombre,
              posicion: posicionCentral
            };
          });
          this.$store.commit("navegacionSig/actualizarObjetosSig", objetosSig);

          me.llamadaApi = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {},
  watch: {
    campos: {
      handler: function (val, oldVal) {
        this.infocliente.campos = this.campos;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.contenedorMapa {
  width: 100%;
  height: 100%;
}

.menuLeft {
  position: absolute;
  left: 20px;
  top: 15px;
  z-index: 130;
  border: none;
}

/* loading */

.loader {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loader-wheel {
  animation: spin 1s infinite linear;
  border: 2px solid rgba(30, 30, 30, 0.5);
  border-left: 4px solid #fff;
  border-radius: 50%;
  height: 50px;
  margin-bottom: 10px;
  width: 50px;
}

.loader-text {
  color: #fff;
  font-family: arial, sans-serif;
}

.loader-text:after {
  content: 'Cargando';
  animation: load 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes load {
  0% {
    content: 'Cargando';
  }

  33% {
    content: 'Cargando.';
  }

  67% {
    content: 'Cargando..';
  }

  100% {
    content: 'Cargando...';
  }
}
</style>